import { useState } from 'react';

export default function Services() {
  const [expandedService, setExpandedService] = useState<number | null>(null);
  const [expandedCase, setExpandedCase] = useState<number | null>(null);
  const [expandedChannels, setExpandedChannels] = useState(false);
  const [showStandardServices, setShowStandardServices] = useState(false);
  const [showPremiumPartnership, setShowPremiumPartnership] = useState(false);
  const [showOzonConsulting, setShowOzonConsulting] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    contact: '',
    website: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const premiumServices = [
    {
      id: 'service-digital-360',
      title: 'Цифровой Маркетинг 360°',
      subtitle: 'Построение цифровой экосистемы бизнеса',
      description: 'Комплексное решение, объединяющее все онлайн-каналы в единый механизм. Мы не просто запускаем рекламу, мы создаем цифровую среду вокруг вашего бренда, используя технологии ИИ для максимизации охвата и конверсии.',
      icon: 'ri-global-line',
      color: 'from-slate-900 via-blue-900 to-slate-900',
      features: [
        'Разработка омниканальной стратегии (сайт + соцсети + рассылки + реклама)',
        'Внедрение сквозной аналитики',
        'Автоматизация коммуникации (чат-боты, автоворонки)',
        'Управление репутацией в сети (SERM)',
        'Доминирование в цифровом пространстве'
      ],
      result: 'Ваша компания доминирует в цифровом пространстве, а клиент «касается» вашего бренда на всех этапах принятия решения.',
      cta: 'Обсудить экосистему'
    },
    {
      id: 'service-complex-strategy',
      title: 'Комплексная стратегия',
      subtitle: 'Разработка под ключ',
      description: 'Полная цифровая трансформация маркетинга вашего бизнеса. Мы создаем работающую систему от анализа до внедрения, которая приносит стабильный результат.',
      icon: 'ri-compass-3-line',
      color: 'from-indigo-900 via-purple-900 to-indigo-900',
      features: [
        'Глубокий анализ бизнеса и конкурентов',
        'Построение воронки продаж',
        'Выбор оптимальных каналов',
        'План внедрения на 6-12 месяцев',
        'Обучение вашей команды'
      ],
      cta: 'Получить план развития'
    },
    {
      id: 'service-consulting',
      title: 'Консалтинг по маркетингу',
      subtitle: 'Стратегический взгляд сверху',
      description: 'Глубокий аудит вашего бизнеса и поиск точек роста. Мы находим скрытые возможности и даем четкий план действий для масштабирования.',
      icon: 'ri-lightbulb-line',
      color: 'from-red-900 via-rose-900 to-red-900',
      features: [
        'Аудит текущего маркетинга',
        'Анализ конкурентов с помощью AI',
        'Поиск точек роста',
        'Персональная презентация результатов',
        'Дорожная карта развития'
      ],
      cta: 'Узнать точки роста'
    },
    {
      id: 'service-partnership',
      title: 'Стратегическое управление и Партнерство',
      subtitle: 'Premium-услуга для производителей на WB и Ozon',
      description: 'Мы не работаем как поточное агентство. Мы заходим в ваш бизнес как Партнеры, которые берут на себя ответственность за создание системы маркетинга и конечную прибыль.',
      icon: 'ri-vip-diamond-line',
      color: 'from-purple-900 via-pink-900 to-purple-900',
      isPremiumPartnership: true,
      forWhom: 'Для Производителей, которые готовы делегировать построение отдела продаж на маркетплейсах профессиональным Управляющим.',
      comparisonTable: {
        title: 'Управляющий Партнер vs Обычный Менеджер',
        subtitle: 'Почему вам нужен стратег, а не просто исполнитель?',
        rows: [
          {
            aspect: 'Позиция',
            manager: 'Наемный сотрудник, выполняющий поручения. Ждет, что ему скажут делать.',
            partner: 'Партнер бизнеса. Проявляем инициативу, сами говорим собственнику, что делать для роста. Относимся к проекту как к своему.'
          },
          {
            aspect: 'Мотивация',
            manager: 'Оклад. Часто не мотивирован делать больше минимума.',
            partner: 'Результат и Прибыль. Работаем за Fix (покрытие издержек) + % от чистой прибыли. Заинтересованы в оптимизации ваших расходов.'
          },
          {
            aspect: 'Зона ответственности',
            manager: 'Частичная (карточки, ответы на отзывы). Требует постоянного контроля и проверок.',
            partner: 'Все бизнес-процессы «под ключ». Сами себе руководители. Выстраиваем и контролируем отдел маркетинга.'
          },
          {
            aspect: 'Развитие',
            manager: 'Работает с тем, что есть.',
            partner: 'Работаем с ассортиментной матрицей, предлагаем ввод новых товаров, запускаем новые направления и каналы продаж.'
          }
        ]
      },
      approach: {
        title: 'Наш подход: Глубина вместо Массовки',
        subtitle: 'Мы работаем индивидуально и не берем проекты «пачками».',
        points: [
          {
            label: 'Фокус',
            text: 'Берем в работу максимум 1–2 проекта одновременно.'
          },
          {
            label: 'Погружение',
            text: 'Мы полностью интегрируемся в ваш бизнес. Мы не сторонние наблюдатели, мы ощущаем пульс проекта, контролируем каждую цифру и видим ситуацию изнутри.'
          },
          {
            label: 'Команда',
            text: 'Один в поле не воин. Маркетплейсы — это сложная система. Наша задача — не делать все в одиночку, а выстроить эффективную команду: повышение эффективности текущих сотрудников, автоматизация рутины, найм и обучение новых специалистов под задачи стратегии.'
          }
        ],
        philosophy: 'Мы работаем на ваш личный доход. Высокий чек обусловлен тем, что мы тратим на вас своё время, экспертность и гарантируем глубокое погружение, недоступное обычным агентствам.'
      },
      credentials: {
        title: 'Почему нам доверяют управление бизнесом?',
        subtitle: 'Путь нашего руководителя — это стремительный рост от специалиста до руководителя, подтвержденный результатами в топовых командах рынка.',
        achievements: [
          {
            title: 'Школа лидеров рынка',
            text: 'Опыт работы в команде топ-селлера и коуча Лео Шевченко (Консалтинговое агентство «Меркатус»). Мы знаем, как работают лучшие стратегии изнутри.'
          },
          {
            title: 'Рекордный карьерный рост',
            points: [
              'За 3 месяца: Рост с позиции линейного Менеджера до Руководителя группы менеджеров в агентстве «Меркатус» благодаря системному подходу и лидерским качествам.',
              'За 1 год: Путь от Менеджера до Управляющего Стратега, который строит отделы маркетинга с нуля. Обучение и практика в рекламном агентстве Convert Monster'
            ]
          },
          {
            title: 'Квалификация',
            text: 'Профильное образование: «Менеджер по продажам на маркетплейсах» (декабрь 2021). Экспертиза в запуске разных ниш и понимание маркетплейсов как комплексной экосистемы, где важен каждый винтик: от SEO до Unit-экономики.'
          }
        ]
      },
      cta: 'Обсудить партнерство'
    },
    {
      id: 'service-ozon',
      title: 'Консалтинг маркетплейс Ozon',
      subtitle: 'Цифры, Аналитика, Прибыль, AI-Автоматизация',
      description: 'Маркетплейс — это прежде всего математика. Мы не просто «продвигаем карточки», мы внедряем систему управленческого учета, чтобы вы торговали в плюс, а не ради оборота.',
      icon: 'ri-line-chart-line',
      color: 'from-emerald-900 via-teal-900 to-emerald-900',
      features: [
        'Юнит-экономика: расчет по каждому SKU (себестоимость, логистика, комиссии)',
        'Контроль метрик: маржинальность, валовая прибыль, рентабельность, ROI',
        'Система отчетности: еженедельные и ежемесячные сводки по продажам',
        'Умная логистика: планирование поставок и контроль остатков',
        'Технологическая автоматизация: VBA, макросы, AI для обработки Big Data',
        'Внешний трафик: соцсети, контекст, таргет, блогеры, лендинги',
        'Управленческий учет (DDS) для избежания кассовых разрывов'
      ],
      result: 'Вы видите не просто «какие-то продажи», а четкую финансовую модель вашего бизнеса на маркетплейсе.',
      result2: 'Вы получаете технологичного партнера, который управляет вашим магазином с точностью машины и скоростью ИИ.',
      cta: 'Рассчитать юнит-экономику',
      sections: [
        {
          emoji: '💰',
          title: 'Юнит-экономика и Финансы',
          subtitle: 'Основа',
          description: 'Мы считаем деньги до того, как их потратить. Никаких действий наугад.',
          points: [
            'Детальный расчет по каждому SKU: Себестоимость, логистика, комиссии',
            'Контроль ключевых метрик в реальном времени: Маржинальность, Валовая прибыль, % Наценки, Рентабельность, ROI',
            'Расчет акций: математический просчет участия товара в акции',
            'Управленческий учет (DDS): ведение отчета о Движении Денежных Средств'
          ]
        },
        {
          emoji: '📈',
          title: 'Прозрачная система отчетности',
          subtitle: 'Контроль',
          description: 'Вы всегда держите руку на пульсе бизнеса благодаря регулярным сводкам.',
          points: [
            'Еженедельные отчеты: динамика продаж, заказов и выкупов',
            'Ежемесячный сводный отчет: детальная аналитика по артикулам',
            'Отчетность по внутренней рекламе: оплата за клик и оплата за заказ'
          ]
        },
        {
          emoji: '📦',
          title: 'Умная Логистика и Планирование',
          subtitle: 'Supply Chain',
          description: 'Исключаем ситуации Out-of Stock (нет в наличии) и Overstock (затоваривание).',
          points: [
            'Сводная таблица по остаткам: глубокий анализ запасов в разрезе каждого кластера и склада',
            'Планирование поставок: автоматический расчет необходимого подсорта',
            'Формирование поставок: подготовка сводного файла поставки для загрузки в личный кабинет Ozon в один клик'
          ]
        },
        {
          emoji: '🤖',
          title: 'Технологическая Автоматизация',
          subtitle: 'VBA + AI',
          description: 'Наше конкурентное преимущество — видеть то, что можно автоматизировать, и внедрять это.',
          points: [
            'Работа с Big Data: легко обрабатываем массивы данных на 1000+ артикулов и миллионы строк Excel',
            'VBA и Макросы: используем язык программирования Visual Basic для написания скриптов',
            'Искусственный Интеллект: применяем последние версии нейросетей для анализа данных и поиска оптимизаций',
            'Результат: Вы платите за стратегию и результат, а не за часы ручной работы в таблицах'
          ]
        },
        {
          emoji: '🌐',
          title: 'Внешний трафик',
          subtitle: 'Масштабирование',
          description: 'Ozon поощряет внешний трафик, и мы умеем с ним работать.',
          points: [
            'Соцсети: ведение и прогрев аудитории',
            'Платная реклама: контекст (Яндекс) и таргет на товар',
            'Работа с блогерами: интеграции у лидеров мнений',
            'Лендинги: создание отдельных сайтов для сбора внешней аудитории'
          ]
        }
      ]
    }
  ];

  const services = [
    {
      title: 'Контекстная реклама',
      subtitle: 'Yandex.Direct, Google Ads',
      emoji: '🎯',
      tagline: 'Ловим «горячий» спрос',
      description: 'Работаем с клиентами, которые уже ищут ваш продукт. Мы не просто настраиваем кампании, а внедряем систему управления ставками для максимального ROI.',
      icon: 'ri-search-line',
      color: 'from-blue-500 to-cyan-500',
      features: [
        'Сбор семантического ядра, минус-слова',
        'Написание продающих объявлений',
        'Ретаргетинг',
        'Постоянная аналитика и снижение стоимости клика'
      ],
      result: 'Целевой трафик с первого дня запуска'
    },
    {
      title: 'Таргетированная реклама',
      subtitle: 'Instagram, Facebook, VKontakte',
      emoji: '⚡️',
      tagline: 'Точное попадание в целевую аудиторию',
      description: 'Используем алгоритмы соцсетей и ИИ, чтобы найти ваших клиентов еще до того, как они начали искать вас. Создаем креативы, которые пробивают «баннерную слепоту».',
      icon: 'ri-focus-3-line',
      color: 'from-purple-500 to-pink-500',
      features: [
        'Сегментация аудитории',
        'A/B тестирование креативов',
        'Настройка пикселей для отслеживания конверсий',
        'Масштабирование успешных связок'
      ],
      result: 'Поток заявок от аудитории, которая максимально заинтересована в вашем предложении'
    },
    {
      title: 'SMM: Наполнение и ведение',
      subtitle: 'Instagram, Facebook, VK, Telegram',
      emoji: '💎',
      tagline: 'Контент, который продает без слов',
      description: 'Превращаем ваши соцсети из скучной «доски объявлений» в живое комьюнити. Разрабатываем единый визуальный стиль и Tone of Voice, который вызывает доверие и лояльность.',
      icon: 'ri-chat-smile-3-line',
      color: 'from-green-500 to-emerald-500',
      features: [
        'Контент-стратегия',
        'Профессиональный копирайтинг',
        'Дизайн постов и сторис',
        'Администрирование и работа с комментариями',
        'Развитие Telegram-канала'
      ],
      result: 'Рост подписной базы, вовлеченности и повторных продаж через соцсети'
    },
    {
      title: 'Создание продающих сайтов',
      subtitle: 'Ваша главная машина продаж 24/7',
      emoji: '💻',
      tagline: 'Маркетинговый инструмент с высокой конверсией',
      description: 'Мы не делаем сайты «для красоты». Мы создаем маркетинговые инструменты с высокой конверсией. Продуманная структура ведет посетителя за руку от заголовка до кнопки «Купить».',
      icon: 'ri-window-line',
      color: 'from-orange-500 to-amber-500',
      features: [
        'Прототипирование',
        'UX/UI дизайн',
        'Верстка, адаптация под мобильные устройства',
        'Базовая SEO-оптимизация',
        'Интеграция с CRM'
      ],
      result: 'Сайт, который превращает посетителей в заявки, а не просто висит в интернете'
    }
  ];

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('contact', formData.contact);
      if (formData.website) {
        formBody.append('website', formData.website);
      }

      const response = await fetch('https://readdy.ai/api/form/d4jj1ukucjmktht589ag', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', contact: '', website: '' });
        setTimeout(() => {
          setShowPopup(false);
          setSubmitStatus('idle');
        }, 2000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <section id="services" className="py-24 bg-white relative overflow-hidden" style={{ fontFamily: "'Montserrat', sans-serif" }}>
        {/* Decorative background */}
        <div className="absolute top-0 left-0 w-full h-2" style={{ background: '#C5A880' }}></div>
        <div className="absolute top-0 right-0 w-96 h-96 rounded-full opacity-5 pointer-events-none" style={{ background: '#1A2B4C', transform: 'translate(30%, -30%)' }}></div>
        <div className="absolute bottom-0 left-0 w-80 h-80 rounded-full opacity-5 pointer-events-none" style={{ background: '#C5A880', transform: 'translate(-30%, 30%)' }}></div>

        <div className="max-w-7xl mx-auto px-6">
          {/* Section Header */}
          <div className="text-center mb-20">
            <div className="inline-flex items-center gap-3 mb-6">
              <div className="h-px w-12" style={{ background: '#C5A880' }}></div>
              <span className="text-xs font-bold tracking-[0.25em] uppercase" style={{ color: '#C5A880', fontFamily: "'Montserrat', sans-serif" }}>Наши услуги</span>
              <div className="h-px w-12" style={{ background: '#C5A880' }}></div>
            </div>
            <h2 className="text-5xl md:text-6xl font-bold mb-6" style={{ fontFamily: "'Playfair Display', serif", color: '#1A2B4C' }}>
              Наши Услуги
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Выберите готовое решение или создадим индивидуальную стратегию под ваш бизнес
            </p>
          </div>

          {/* Premium Services */}
          <div className="space-y-8 mb-16">
            {premiumServices.map((service, index) => (
              service.isPremiumPartnership ? (
                // Premium Partnership - Collapsible
                <div key={index} id={service.id}>
                  <button
                    onClick={() => setShowPremiumPartnership(!showPremiumPartnership)}
                    className="w-full rounded-2xl p-10 shadow-xl relative overflow-hidden group transition-all duration-500 text-left cursor-pointer border"
                    style={{ background: '#1A2B4C', borderColor: '#C5A880' }}
                  >
                    {/* Decorative rings */}
                    <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full border-2 opacity-10 pointer-events-none" style={{ borderColor: '#C5A880' }}></div>
                    <div className="absolute -bottom-16 -left-16 w-48 h-48 rounded-full border opacity-10 pointer-events-none" style={{ borderColor: '#C5A880' }}></div>

                    <div className="relative z-10 flex items-center justify-between gap-6">
                      <div className="flex-1 text-center">
                        <div className="inline-block px-5 py-2 rounded-full text-xs font-bold tracking-widest uppercase mb-5" style={{ background: '#C5A880', color: '#1A2B4C', fontFamily: "'Montserrat', sans-serif" }}>
                          💎 PREMIUM-УСЛУГА
                        </div>
                        <p className="text-sm font-semibold mb-2 tracking-wide" style={{ color: '#C5A880', fontFamily: "'Montserrat', sans-serif" }}>
                          Premium-услуга для производителей на WB и Ozon
                        </p>
                        <h3 className="text-3xl md:text-4xl font-bold text-white" style={{ fontFamily: "'Playfair Display', serif" }}>
                          Стратегическое управление и Партнерство
                        </h3>
                      </div>
                      <div className={`w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 transition-transform duration-300 border ${showPremiumPartnership ? 'rotate-180' : ''}`} style={{ borderColor: '#C5A880', background: 'rgba(197,168,128,0.15)' }}>
                        <i className="ri-arrow-down-s-line text-2xl" style={{ color: '#C5A880' }}></i>
                      </div>
                    </div>
                  </button>

                  {showPremiumPartnership && (
                    <div className="mt-4 rounded-2xl p-12 shadow-xl relative overflow-hidden border" style={{ background: '#1A2B4C', borderColor: '#C5A880' }}>
                      <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full border opacity-10 pointer-events-none" style={{ borderColor: '#C5A880' }}></div>
                      <div className="relative z-10">
                        <div className="text-center mb-12">
                          <p className="text-gray-300 text-lg leading-relaxed max-w-4xl mx-auto mb-6">{service.description}</p>
                          <div className="rounded-xl p-5 max-w-3xl mx-auto border" style={{ background: 'rgba(197,168,128,0.08)', borderColor: 'rgba(197,168,128,0.3)' }}>
                            <p className="text-xs font-bold tracking-widest uppercase mb-2" style={{ color: '#C5A880' }}>Для кого:</p>
                            <p className="text-white text-base leading-relaxed">{service.forWhom}</p>
                          </div>
                        </div>

                        {/* Comparison Table */}
                        <div className="mb-12">
                          <div className="text-center mb-8">
                            <h4 className="text-3xl font-bold text-white mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>🤝 {service.comparisonTable.title}</h4>
                            <p className="text-gray-300">{service.comparisonTable.subtitle}</p>
                          </div>
                          <div className="overflow-x-auto">
                            <table className="w-full rounded-2xl overflow-hidden border" style={{ borderColor: 'rgba(197,168,128,0.2)', background: 'rgba(255,255,255,0.04)' }}>
                              <thead>
                                <tr style={{ background: 'rgba(197,168,128,0.12)' }}>
                                  <th className="px-6 py-4 text-left text-white font-bold"></th>
                                  <th className="px-6 py-4 text-center text-white font-bold">
                                    <div className="flex items-center justify-center gap-2">
                                      <span className="text-2xl">👷</span>
                                      <span>Обычный Менеджер<br /><span className="text-sm font-normal text-gray-400">(«Руки»)</span></span>
                                    </div>
                                  </th>
                                  <th className="px-6 py-4 text-center font-bold" style={{ color: '#C5A880', background: 'rgba(197,168,128,0.1)' }}>
                                    <div className="flex items-center justify-center gap-2">
                                      <span className="text-2xl">👑</span>
                                      <span>Управляющий Партнер<br /><span className="text-sm font-normal" style={{ color: '#C5A880' }}>(«Голова и Система»)</span></span>
                                    </div>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {service.comparisonTable.rows.map((row, idx) => (
                                  <tr key={idx} className="border-t" style={{ borderColor: 'rgba(197,168,128,0.15)' }}>
                                    <td className="px-6 py-4 font-bold text-sm" style={{ color: '#C5A880' }}>{row.aspect}</td>
                                    <td className="px-6 py-4 text-gray-400 text-sm">{row.manager}</td>
                                    <td className="px-6 py-4 text-white text-sm" style={{ background: 'rgba(197,168,128,0.06)' }}>{row.partner}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>

                        {/* Approach */}
                        <div className="mb-12 rounded-2xl p-8 border" style={{ background: 'rgba(255,255,255,0.04)', borderColor: 'rgba(197,168,128,0.2)' }}>
                          <div className="text-center mb-8">
                            <h4 className="text-3xl font-bold text-white mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>🚀 {service.approach.title}</h4>
                            <p className="text-gray-300">{service.approach.subtitle}</p>
                          </div>
                          <div className="grid md:grid-cols-3 gap-6 mb-8">
                            {service.approach.points.map((point, idx) => (
                              <div key={idx} className="rounded-xl p-6 border" style={{ background: 'rgba(255,255,255,0.04)', borderColor: 'rgba(197,168,128,0.2)' }}>
                                <p className="font-bold text-base mb-3" style={{ color: '#C5A880' }}>{point.label}:</p>
                                <p className="text-gray-300 text-sm leading-relaxed">{point.text}</p>
                              </div>
                            ))}
                          </div>
                          <div className="rounded-xl p-6 border" style={{ background: 'rgba(197,168,128,0.08)', borderColor: 'rgba(197,168,128,0.3)' }}>
                            <p className="text-xs font-bold tracking-widest uppercase mb-2" style={{ color: '#C5A880' }}>Наша философия:</p>
                            <p className="text-white text-base leading-relaxed">{service.approach.philosophy}</p>
                          </div>
                        </div>

                        {/* Credentials */}
                        <div className="mb-12">
                          <div className="text-center mb-8">
                            <h4 className="text-3xl font-bold text-white mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>🏆 {service.credentials.title}</h4>
                            <p className="text-gray-300">{service.credentials.subtitle}</p>
                          </div>
                          <div className="grid md:grid-cols-3 gap-6">
                            {service.credentials.achievements.map((achievement, idx) => (
                              <div key={idx} className="rounded-2xl p-6 border" style={{ background: 'rgba(255,255,255,0.04)', borderColor: 'rgba(197,168,128,0.2)' }}>
                                <h5 className="text-lg font-bold mb-4" style={{ color: '#C5A880', fontFamily: "'Playfair Display', serif" }}>{achievement.title}</h5>
                                {achievement.text && <p className="text-gray-300 text-sm leading-relaxed">{achievement.text}</p>}
                                {achievement.points && (
                                  <ul className="space-y-3">
                                    {achievement.points.map((point, pidx) => (
                                      <li key={pidx} className="flex items-start gap-2">
                                        <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{ background: '#C5A880' }}>
                                          <i className="ri-check-line text-white text-xs"></i>
                                        </div>
                                        <span className="text-gray-200 text-sm">{point}</span>
                                      </li>
                                    ))}
                                  </ul>
                                )}
                              </div>
                            ))}
                          </div>
                        </div>

                        {/* CTA */}
                        <div className="text-center">
                          <button
                            onClick={() => { document.getElementById('lead-form')?.scrollIntoView({ behavior: 'smooth' }); }}
                            className="px-10 py-5 rounded-xl font-bold text-lg transition-all duration-300 shadow-lg whitespace-nowrap cursor-pointer hover:opacity-90"
                            style={{ background: '#C5A880', color: '#1A2B4C', fontFamily: "'Montserrat', sans-serif" }}
                          >
                            Записаться на стратегическое интервью
                          </button>
                          <p className="text-gray-400 text-sm mt-3">Обсудим ваш проект и поймем, подходим ли мы друг другу для партнерства.</p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ) : service.sections ? (
                // Ozon Service - Collapsible
                <div key={index} id={service.id}>
                  <button
                    onClick={() => setShowOzonConsulting(!showOzonConsulting)}
                    className="w-full rounded-2xl p-10 shadow-xl relative overflow-hidden group transition-all duration-500 text-left cursor-pointer border"
                    style={{ background: '#F8F9FA', borderColor: '#C5A880' }}
                  >
                    <div className="absolute -top-10 -right-10 w-48 h-48 rounded-full opacity-10 pointer-events-none" style={{ background: '#1A2B4C' }}></div>
                    <div className="relative z-10 flex items-center justify-between gap-6">
                      <div className="flex-1">
                        <div className="flex items-center gap-5">
                          <div className="w-16 h-16 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: '#1A2B4C' }}>
                            <i className={`${service.icon} text-3xl`} style={{ color: '#C5A880' }}></i>
                          </div>
                          <div>
                            <h3 className="text-2xl md:text-3xl font-bold mb-1" style={{ fontFamily: "'Playfair Display', serif", color: '#1A2B4C' }}>
                              {service.title}
                            </h3>
                            <p className="text-sm font-semibold" style={{ color: '#C5A880', fontFamily: "'Montserrat', sans-serif" }}>
                              {service.subtitle}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className={`w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 border transition-transform duration-300 ${showOzonConsulting ? 'rotate-180' : ''}`} style={{ borderColor: '#C5A880', background: 'rgba(197,168,128,0.1)' }}>
                        <i className="ri-arrow-down-s-line text-2xl" style={{ color: '#1A2B4C' }}></i>
                      </div>
                    </div>
                  </button>

                  {showOzonConsulting && (
                    <div className="mt-4 rounded-2xl p-12 shadow-xl relative overflow-hidden border" style={{ background: '#1A2B4C', borderColor: '#C5A880' }}>
                      <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full border opacity-10 pointer-events-none" style={{ borderColor: '#C5A880' }}></div>
                      <div className="relative z-10">
                        <div className="text-center mb-12">
                          <p className="text-gray-300 text-lg leading-relaxed max-w-4xl mx-auto">{service.description}</p>
                        </div>

                        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
                          {service.sections.map((section, idx) => (
                            <div key={idx} className="rounded-2xl p-6 border" style={{ background: 'rgba(255,255,255,0.05)', borderColor: 'rgba(197,168,128,0.25)' }}>
                              <div className="text-4xl mb-4">{section.emoji}</div>
                              <h4 className="text-xl font-bold text-white mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>{section.title}</h4>
                              <p className="text-xs font-bold tracking-widest uppercase mb-3" style={{ color: '#C5A880' }}>{section.subtitle}</p>
                              <p className="text-gray-300 text-sm mb-4 leading-relaxed">{section.description}</p>
                              <ul className="space-y-2">
                                {section.points.map((point, pidx) => (
                                  <li key={pidx} className="flex items-start gap-2">
                                    <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{ background: '#C5A880' }}>
                                      <i className="ri-check-line text-white text-xs"></i>
                                    </div>
                                    <span className="text-gray-200 text-sm">{point}</span>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          ))}
                        </div>

                        <div className="text-center">
                          <div className="rounded-xl p-6 mb-8 max-w-3xl mx-auto border space-y-3" style={{ background: 'rgba(197,168,128,0.08)', borderColor: 'rgba(197,168,128,0.3)' }}>
                            <p className="text-xs font-bold tracking-widest uppercase mb-2" style={{ color: '#C5A880' }}>✅ Результат:</p>
                            <p className="text-white text-base leading-relaxed">{service.result}</p>
                            {service.result2 && <p className="text-white text-base leading-relaxed">{service.result2}</p>}
                          </div>
                          <button
                            onClick={() => { document.getElementById('lead-form')?.scrollIntoView({ behavior: 'smooth' }); }}
                            className="px-10 py-5 rounded-xl font-bold text-base transition-all duration-300 shadow-lg whitespace-nowrap cursor-pointer hover:opacity-90"
                            style={{ background: '#C5A880', color: '#1A2B4C', fontFamily: "'Montserrat', sans-serif" }}
                          >
                            {service.cta}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                // Standard Premium Service
                <div
                  key={index}
                  id={service.id}
                  className="rounded-2xl p-12 shadow-xl relative overflow-hidden group transition-all duration-500 border hover:shadow-2xl"
                  style={{ background: '#F8F9FA', borderColor: '#C5A880' }}
                >
                  <div className="absolute top-0 right-0 w-64 h-64 rounded-full opacity-5 pointer-events-none" style={{ background: '#1A2B4C', transform: 'translate(30%, -30%)' }}></div>
                  <div className="relative z-10 grid lg:grid-cols-2 gap-12 items-center">
                    <div>
                      <div className="w-20 h-20 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-105 transition-transform duration-300" style={{ background: '#1A2B4C' }}>
                        <i className={`${service.icon} text-4xl`} style={{ color: '#C5A880' }}></i>
                      </div>
                      <h3 className="text-4xl font-bold mb-3" style={{ fontFamily: "'Playfair Display', serif", color: '#1A2B4C' }}>
                        {service.title}
                      </h3>
                      <p className="text-base font-semibold mb-6 tracking-wide" style={{ color: '#C5A880', fontFamily: "'Montserrat', sans-serif" }}>
                        {service.subtitle}
                      </p>
                      <p className="text-gray-600 text-base leading-relaxed mb-8">{service.description}</p>
                      {service.result && (
                        <div className="rounded-xl p-5 mb-8 border" style={{ background: 'rgba(197,168,128,0.08)', borderColor: 'rgba(197,168,128,0.4)' }}>
                          <p className="text-xs font-bold tracking-widest uppercase mb-2" style={{ color: '#C5A880' }}>Результат:</p>
                          <p className="text-gray-800 text-sm leading-relaxed">{service.result}</p>
                        </div>
                      )}
                      <button
                        onClick={() => { document.getElementById('lead-form')?.scrollIntoView({ behavior: 'smooth' }); }}
                        className="px-8 py-4 rounded-xl font-bold text-sm transition-all duration-300 shadow-md whitespace-nowrap cursor-pointer hover:opacity-90"
                        style={{ background: '#1A2B4C', color: '#C5A880', fontFamily: "'Montserrat', sans-serif" }}
                      >
                        {service.cta}
                      </button>
                    </div>

                    <div className="rounded-2xl p-8 border" style={{ background: 'white', borderColor: 'rgba(197,168,128,0.3)' }}>
                      <h4 className="text-lg font-bold mb-6" style={{ color: '#1A2B4C', fontFamily: "'Playfair Display', serif" }}>Что входит:</h4>
                      <ul className="space-y-4">
                        {service.features.map((feature, idx) => (
                          <li key={idx} className="flex items-start gap-3">
                            <div className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{ background: '#C5A880' }}>
                              <i className="ri-check-line text-white text-xs"></i>
                            </div>
                            <span className="text-gray-700 text-sm leading-relaxed">{feature}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              )
            ))}
          </div>

          {/* Standard Services - Collapsible */}
          <div className="mb-12" id="service-standard">
            <button
              onClick={() => setShowStandardServices(!showStandardServices)}
              className="w-full rounded-2xl p-10 shadow-xl relative overflow-hidden group transition-all duration-500 text-left cursor-pointer border"
              style={{ background: '#1A2B4C', borderColor: '#C5A880' }}
            >
              <div className="absolute -top-10 -right-10 w-48 h-48 rounded-full border opacity-10 pointer-events-none" style={{ borderColor: '#C5A880' }}></div>
              <div className="relative z-10 flex items-center justify-between gap-6">
                <div className="flex-1 text-center">
                  <div className="flex items-center justify-center gap-4 mb-4">
                    <div className="w-16 h-16 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: 'rgba(197,168,128,0.2)' }}>
                      <i className="ri-rocket-line text-3xl" style={{ color: '#C5A880' }}></i>
                    </div>
                    <div className="text-left">
                      <p className="text-xs font-bold tracking-widest uppercase mb-1" style={{ color: '#C5A880', fontFamily: "'Montserrat', sans-serif" }}>📢 Отдельные каналы продвижения</p>
                      <h3 className="text-2xl md:text-3xl font-bold text-white" style={{ fontFamily: "'Playfair Display', serif" }}>
                        Комплекс цифровых инструментов для роста
                      </h3>
                    </div>
                  </div>
                  <p className="text-sm font-semibold mb-2" style={{ color: '#C5A880' }}>
                    Контекстная реклама • Таргетированная реклама • SMM • Создание сайтов
                  </p>
                  <p className="text-gray-300 text-sm">
                    Выберите отдельные инструменты для точечного усиления вашего маркетинга или используйте их в комплексе для максимального эффекта
                  </p>
                </div>
                <div className={`w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 border transition-transform duration-300 ${showStandardServices ? 'rotate-180' : ''}`} style={{ borderColor: '#C5A880', background: 'rgba(197,168,128,0.15)' }}>
                  <i className="ri-arrow-down-s-line text-2xl" style={{ color: '#C5A880' }}></i>
                </div>
              </div>
            </button>

            {showStandardServices && (
              <div className="mt-6 grid md:grid-cols-2 gap-6">
                {services.map((service, index) => (
                  <div
                    key={index}
                    className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden group border"
                    style={{ borderColor: 'rgba(197,168,128,0.3)' }}
                  >
                    {/* Card Header */}
                    <div className="p-8 relative overflow-hidden" style={{ background: '#1A2B4C' }}>
                      <div className="absolute top-4 right-4 text-5xl opacity-10">{service.emoji}</div>
                      <div className="w-14 h-14 rounded-xl flex items-center justify-center mb-4 group-hover:scale-105 transition-transform duration-300" style={{ background: 'rgba(197,168,128,0.2)' }}>
                        <i className={`${service.icon} text-2xl`} style={{ color: '#C5A880' }}></i>
                      </div>
                      <h3 className="text-2xl font-bold text-white mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>
                        {service.title}
                      </h3>
                      <p className="text-xs font-semibold mb-2 tracking-wide" style={{ color: '#C5A880', fontFamily: "'Montserrat', sans-serif" }}>
                        {service.subtitle}
                      </p>
                      <p className="text-sm font-bold" style={{ color: '#C5A880' }}>{service.tagline}</p>
                    </div>

                    <div className="p-6">
                      <p className="text-gray-600 text-sm leading-relaxed mb-5">{service.description}</p>
                      <div className="mb-5">
                        <h4 className="text-xs font-bold tracking-widest uppercase mb-3" style={{ color: '#1A2B4C' }}>Что входит:</h4>
                        <ul className="space-y-2">
                          {service.features.map((feature, idx) => (
                            <li key={idx} className="flex items-start gap-2 text-sm text-gray-600">
                              <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                                <i className="ri-check-line text-xs" style={{ color: '#C5A880' }}></i>
                              </div>
                              <span>{feature}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div className="rounded-xl p-4 border" style={{ background: 'rgba(197,168,128,0.06)', borderColor: 'rgba(197,168,128,0.3)' }}>
                        <p className="text-xs font-bold tracking-widest uppercase mb-1" style={{ color: '#C5A880' }}>Результат:</p>
                        <p className="text-sm text-gray-700 leading-relaxed">{service.result}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Bottom CTA */}
          <div className="mt-16 text-center">
            <div className="inline-flex items-center gap-3 mb-6">
              <div className="h-px w-16" style={{ background: '#C5A880' }}></div>
              <span className="text-xs font-bold tracking-[0.25em] uppercase" style={{ color: '#C5A880' }}>Готовы начать?</span>
              <div className="h-px w-16" style={{ background: '#C5A880' }}></div>
            </div>
            <br />
            <button
              onClick={() => { document.getElementById('lead-form')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="px-12 py-5 rounded-xl font-bold text-base transition-all duration-300 shadow-xl whitespace-nowrap cursor-pointer hover:opacity-90"
              style={{ background: '#1A2B4C', color: '#C5A880', fontFamily: "'Montserrat', sans-serif" }}
            >
              Рассчитать стоимость услуг
            </button>
          </div>
        </div>
      </section>

      {/* Popup Modal */}
      {showPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm">
          <div className="rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-2xl border" style={{ background: '#1A2B4C', borderColor: '#C5A880' }}>
            <div className="p-8 md:p-10">
              <button onClick={() => setShowPopup(false)} className="float-right text-gray-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-close-line text-3xl"></i>
              </button>

              <div className="mb-8">
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                  Ваш маркетинг работает на 100% или сливает бюджет?
                </h2>
                <p className="text-gray-300 text-base leading-relaxed">
                  Не гадайте. Получите честный взгляд со стороны. Запишитесь на бесплатную 20-минутную экспресс-диагностику вашего проекта.
                </p>
              </div>

              <div className="mb-8 space-y-4">
                <h3 className="text-lg font-semibold mb-4" style={{ color: '#C5A880', fontFamily: "'Playfair Display', serif" }}>Что вы узнаете:</h3>
                <div className="space-y-3">
                  {[
                    { emoji: '🔍', text: 'Где вы теряете клиентов прямо сейчас (поиск «дыр» в воронке).' },
                    { emoji: '📈', text: '3 неочевидные точки роста для масштабирования выручки.' },
                    { emoji: '🤖', text: 'Как ИИ может снизить ваши расходы на рекламу.' }
                  ].map((item, i) => (
                    <div key={i} className="flex items-start gap-3">
                      <span className="text-2xl">{item.emoji}</span>
                      <p className="text-gray-300 text-sm leading-relaxed">{item.text}</p>
                    </div>
                  ))}
                </div>
              </div>

              <form onSubmit={handleSubmit} data-readdy-form id="diagnostic-form" className="space-y-5">
                {[
                  { id: 'name', label: 'Имя', type: 'text', required: true, placeholder: 'Ваше имя', key: 'name' },
                  { id: 'contact', label: 'Телефон / Telegram', type: 'text', required: true, placeholder: '+7 (999) 123-45-67 или @username', key: 'contact' },
                  { id: 'website', label: 'Ссылка на сайт', type: 'url', required: false, placeholder: 'https://example.com', key: 'website' }
                ].map((field) => (
                  <div key={field.id}>
                    <label htmlFor={field.id} className="block text-xs font-bold tracking-widest uppercase mb-2" style={{ color: '#C5A880' }}>
                      {field.label} {field.required && <span className="text-red-400">*</span>}
                      {!field.required && <span className="text-gray-500 normal-case tracking-normal font-normal"> (необязательно)</span>}
                    </label>
                    <input
                      type={field.type}
                      id={field.id}
                      name={field.id}
                      required={field.required}
                      value={formData[field.key as keyof typeof formData]}
                      onChange={(e) => setFormData({ ...formData, [field.key]: e.target.value })}
                      className="w-full px-4 py-3 rounded-xl text-white placeholder-gray-500 focus:outline-none transition-colors text-sm border"
                      style={{ background: 'rgba(255,255,255,0.06)', borderColor: 'rgba(197,168,128,0.3)' }}
                      placeholder={field.placeholder}
                      onFocus={(e) => { e.target.style.borderColor = '#C5A880'; }}
                      onBlur={(e) => { e.target.style.borderColor = 'rgba(197,168,128,0.3)'; }}
                    />
                  </div>
                ))}

                {submitStatus === 'success' && (
                  <div className="rounded-xl p-4 border" style={{ background: 'rgba(197,168,128,0.1)', borderColor: 'rgba(197,168,128,0.4)' }}>
                    <p className="text-center font-medium text-sm" style={{ color: '#C5A880' }}>✓ Заявка успешно отправлена! Мы свяжемся с вами в ближайшее время.</p>
                  </div>
                )}
                {submitStatus === 'error' && (
                  <div className="rounded-xl p-4 border border-red-500/30 bg-red-500/10">
                    <p className="text-red-400 text-center font-medium text-sm">✗ Ошибка отправки. Попробуйте еще раз.</p>
                  </div>
                )}

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full px-8 py-4 rounded-xl font-bold text-sm transition-all duration-300 shadow-lg whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed hover:opacity-90"
                  style={{ background: '#C5A880', color: '#1A2B4C', fontFamily: "'Montserrat', sans-serif" }}
                >
                  {isSubmitting ? 'Отправка...' : 'Узнать точки роста'}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
